export function checkMoreChunksAvailable({
  totalResults,
  currentChunk,
  currentPage,
  pageSize,
  chunkSize,
}: {
  totalResults: number;
  currentChunk: number;
  currentPage: number;
  pageSize: number;
  chunkSize: number;
}) {
  const totalPages = Math.ceil(totalResults / pageSize);
  const currentNumberOfChunkedProducts = chunkSize * currentChunk;
  const totalNumberOfChunkedProducts =
    pageSize * (currentPage - 1) + currentNumberOfChunkedProducts;

  return currentPage >= totalPages
    ? totalNumberOfChunkedProducts < totalResults
    : currentChunk < pageSize / chunkSize;
}
